(function() {
    'use strict';

angular.module('ccsTrApp').directive('loginInfo', loginInfo);

    loginInfo.$inject=['Principal'];

    function loginInfo( Principal ) {
        var directive = {
            restrict: 'A',
            link: linkFunc,
            templateUrl: 'app/layouts/directives/login-info.tpl.html',
        };

        return directive;

        function linkFunc(scope, element) {
            Principal.identity().then(function(account) {
                scope.user = account;
            });
        }
    }
})();
